import { Fragment, memo } from "react";
import { Stack, SystemProps } from "@storyofams/react-ui";
import { Divider, Button } from "../../components";
import { getLinkProps } from "../../lib";

interface LinksProps {
  links: any;
  hasBundles?: boolean;
}

export const Links = memo(
  ({
    links,
    hasBundles = false,
    ...props
  }: LinksProps & Omit<SystemProps, "flexDirection">) => {
    return (
      <Stack mb={["20px", "30px"]} space={0} flexDirection="column" {...props}>
        <Divider />

        {links?.map(({ label, url, _uid }, i) => (
          <Fragment key={_uid}>
            <Button
              href={getLinkProps(url)}
              variant="link-arrow"
              justifyContent="space-between"
              pr={0.5}
              py={!hasBundles && 2}
              pb={2}
              width="100%"
            >
              {label}
            </Button>

            {i < links.length - 1 && <Divider />}
          </Fragment>
        ))}

        {!!links?.length && <Divider />}
      </Stack>
    );
  }
);
